import {Component, ViewChild} from '@angular/core';
import {Http} from '@angular/http';
import { Router } from '@angular/router';
import { ToasterService} from 'angular2-toaster/angular2-toaster';

import { DataTable } from './../../../services/DataTable';
import { ProvincesService } from './../../../models/provinces/provinces.service';
import {LeadsService} from "../../../models/leads/leads.service";
import { CommunicationService } from "../../../models/communication/communication.service";
import {LeadsModel} from "../../../models/leads/leads.model";
import {ProvincesModel} from "../../../models/provinces/provinces.model";
import {PermissionsService} from "../../../services/permissions/permissions.service";
import {BadgesService} from "../../../models/badges/badges.service";
import {BadgesHelper} from "../../../services/BadgesHelper";

import {phoneFormatter} from "../../../helpers/phone-format";

@Component({
    selector: 'lead-list',
    templateUrl: 'lead-list.template.html',
    styleUrls: ['lead-list.css']
})
export class LeadListComponent{
    phoneFormatter = phoneFormatter;
    @ViewChild('leadCreateSchedule') public leadCreateSchedule;
    @ViewChild('leadCreateClient') public leadCreateClient;
    @ViewChild('leadEdit') public leadEdit;
    @ViewChild('confirmDialogDelete') public confirmDialogDelete;
    @ViewChild('snowNotes') public snowNotes;

    public dataTable: DataTable;
    public leadStatuses: Array<any>;
    public Leads = LeadsService;

    private Model: LeadsService;

    public provinceList = <ProvincesModel[]> [];

    public leadSources: any = [];

    public searchSource: any = '';

    is_removed: any = false;


    // ===========================================================
    // Init
    // ===========================================================

    constructor(private http: Http, private router: Router, private toasterService: ToasterService,
                private communicationService: CommunicationService, public provincesService: ProvincesService,
                public permission: PermissionsService,
                public badgesService: BadgesService,
                public badgesHelper: BadgesHelper,
    ) {
        if (this.router.url.split('?')[0] === '/leads/removed') {
            this.is_removed = true;
        }

        var setQ = (() => {
            var a: any = document.createElement('a');
            a.href = this.router.url;
            var url: any = new URL(a.href);
            var q = url.searchParams.get('q');
            return (dataTable: any) => {
                if (q) dataTable.filter.q = q;
            };
        }) ();

        this.Model = new LeadsService(this.http);

        //let fields = this.getFilterFields();
        this.dataTable = new DataTable(this.Model);

        setQ(this.dataTable);

        this.initSetTagsByUrl();
        this.setDataTableFilter();

        this.badgesService.onChange.subscribe((badgesObject)=> {
            badgesHelper.refreshEntity(badgesObject, this.dataTable);
            this.refreshTable();
        })
    }

    ngOnInit() {
        this.leadStatuses = LeadsService.getStatuses();

        this.provincesService.getList()
           .subscribe((res) => {
               this.provinceList = res.data;
               this.calcSearchTagsFrom();
           });

        this.Model.getSources()
           .subscribe((res) => {
               this.leadSources = res.data;
           });
    }

    public openNotesModal(entity: any) {
        entity.notes = entity.notes_list;
        this.snowNotes.show(entity);
        this.badgesService.removeChannel('leads/' + entity.id  + '/notes');
    }


    // ===========================================================
    // Actions
    // ===========================================================

    public showCreateClient(entity:LeadsModel) {
        this.leadCreateClient.show(entity);
    }

    public showEditLead(entity:LeadsModel) {
        this.leadEdit.show(entity);
    }

    public showCreateSchedule(entity:LeadsModel) {
        this.leadCreateSchedule.show(entity);
    }

    public refreshTable() {
        this.dataTable.refresh();
    }

    public sendCall(phoneNumber) {

        if (!confirm("Call " + phoneNumber + '?')) {
            return false;
        }

        this.communicationService.sendCall(phoneNumber);

        this.toasterService.pop('info', 'Info', 'Processing request');
    }


    // ===========================================================
    // Functions
    // ===========================================================

    private getFilterFields(){
        let fields = [];
        fields.push({'visible':  LeadsService.LEAD_VISIBLE_TRUE});

        var a: any = document.createElement('a');
        a.href = this.router.url;
        var url: any = new URL(a.href);
        if (url.searchParams.get('without_coast')) return;

        if(this.router.url.split('?')[0] === '/leads/west-coast'){
            fields.push({'coast': ProvincesService.PROVINCES_COAS_WEST});
        } else {
            fields.push({'coast': ProvincesService.PROVINCES_COAS_EAST});
        }
        return fields;
    }

    public searchTagsEW = [
        {id: 'e', name: 'East Coast'},
        {id: 'w', name: 'West Coast'}
    ];

    public searchTagsEWFrom: any = [];
    public searchTagsFrom: any = [];
    public searchTagsTo: any = [];

    public searchTagsEWFromA: any = [];
    public searchTagsFromA: any = [];

    private searchTagsIds: any = [];

    public isTagFilterShow: boolean = false;

    selectTagEW(id, sel = true) {
        this.selectTag(id, sel);
    }

    selectTag(id, sel = true) {
        if (sel) {
            this.addTagsTo(id);
            this.setDataTableFilter();
        } else this.removeTagsTo(id);
    }

    private calcSearchTagsFrom() {
        this.searchTagsFrom = [];
        this.searchTagsEWFrom = [];
        this.searchTagsFromA = [];
        this.searchTagsEWFromA = [];
        for (let el of this.searchTagsEW) {
            let elA = Object.assign({sel: false}, el);
            if (this.searchTagsIds.indexOf(el.id) < -0.1) {
                this.searchTagsEWFrom.push(el);
                elA.sel = true;
            }
            this.searchTagsEWFromA.push(elA);
        }
        for (let el of this.provinceList) {
            let elA = Object.assign({sel: false}, el);
            if (this.searchTagsIds.indexOf(el.id) < -0.1) {
                this.searchTagsFrom.push(el);
                elA.sel = true;
            }
            this.searchTagsFromA.push(elA);
        }
    }

    private addTagsTo(id) {
        if (this.searchTagsIds.indexOf(id) > -0.1) return;
        if (['e', 'w'].indexOf(id) > -0.1) {
            this.searchTagsIds = [id];
        } else {
            if (this.searchTagsIds.indexOf('e') > -0.1 || this.searchTagsIds.indexOf('w') > -0.1) {
                this.searchTagsIds = [];
            }
            this.searchTagsIds.push(id);
        }
        this.recalcFromTo();
    }

    private calcSearchTagsTo() {
        this.searchTagsTo = [];
        for (let el of this.searchTagsEW) {
            if (this.searchTagsIds.indexOf(el.id) > -0.1) this.searchTagsTo.push(el);
        }
        for (let el of this.provinceList) {
            if (this.searchTagsIds.indexOf(el.id) > -0.1) this.searchTagsTo.push(el);
        }
    }

    private recalcFromTo() {
        this.calcSearchTagsTo();
        this.calcSearchTagsFrom();
    }

    tagsFilterShow() {
        this.isTagFilterShow = ! this.isTagFilterShow;
    }

    removeTagsTo(id) {
        let idx = this.searchTagsIds.indexOf(id);
        if (idx < -0.1) return;
        this.searchTagsIds.splice(idx, 1);
        this.recalcFromTo();
        this.setDataTableFilter();
    }

    initSetTagsByUrl() {
        if (this.router.url.split('?')[0] === '/leads/west-coast') this.addTagsTo('w');
        else if (this.router.url.split('?')[0] === '/leads/east-coast') this.addTagsTo('e');
    }

    setDataTableFilter() {
        let fields = [];
        fields.push({
            'visible': 
                this.is_removed ? 
                    LeadsService.LEAD_VISIBLE_FALSE : LeadsService.LEAD_VISIBLE_TRUE
        });
        if (this.searchSource) fields.push({'source':  this.searchSource});

        (() => {
            if (this.router.url.split('?')[0] === '/leads/non-qualified') {
                fields.push({'non_qualified': 1});
            }

            if (this.is_removed) {
                fields.push({'status': '!10'});
            }

            if (this.searchTagsIds.indexOf('w') > -0.1) {
                fields.push({'coast': ProvincesService.PROVINCES_COAS_WEST});
                return;
            } else if (this.searchTagsIds.indexOf('e') > -0.1) {
                fields.push({'coast': ProvincesService.PROVINCES_COAS_EAST});
                return;
            } else {
                let province_id = [];
                for (let id of this.searchTagsIds) {
                    province_id.push(id);
                }
                if (province_id.length > 0.1) fields.push({province_id: province_id});
                /* else {
                    if (this.router.url.split('?')[0] === '/leads/west-coast') {
                        fields.push({'coast': ProvincesService.PROVINCES_COAS_WEST});
                    } else if (this.router.url.split('?')[0] === '/leads/east-coast') {
                        fields.push({'coast': ProvincesService.PROVINCES_COAS_EAST});
                    }
                } */
            }
        }) ();

        this.dataTable.setFilter({fields: fields});
    }

    //////

    changeSource() {
        this.setDataTableFilter();
    }



    ////// DELETE CLIENT

    public leadId: any;

    get canDeleteClient() {
        return this.permission.can('leads.delete');
    }

    deleteLead(entry) {
        if (! entry || ! entry.id) return;
        this.leadId = entry.id;
        if (! this.canDeleteClient || this.deleteInProcess) return;
        //this.isDeleteConfirm = true;
        this.confirmDialogDelete.show('Do you want delete this lead #' + this.leadId + '?');
    }

    public isDeleteConfirm = false;
    public deleteInProcess = false;

    hideDeleteConfirm() {
        if (this.deleteInProcess) return;
        this.isDeleteConfirm = false;
    }

    applyDeleteClient() {
        if (! this.canDeleteClient || this.deleteInProcess) return;
        this.deleteInProcess = true;
        this.Model.remove(this.leadId)
            .subscribe(
                (res) => {
                    this.deleteInProcess = false;
                    this.isDeleteConfirm = false;
                    this.toasterService.pop('success', 'Success', 'Deleted');

                    this.dataTable.refresh();
                },
                (error) => {
                    this.deleteInProcess = false;
                    this.isDeleteConfirm = false;
                    this.toasterService.pop('error', 'Error', 'Error deleting a lead. Try again');
                }
            );
    }

    getStatusById(id: any) {
        return this.Model.getStatusById(id);
    }
}


// WEBPACK FOOTER //
// ./src/app/views/leads/list/lead-list.component.ts